import axios from "axios";

const AUTH_DOMAIN = `https://api.getrichpos.com/auth`;

const getTokens = () => {
  return axios.get(`${AUTH_DOMAIN}/auth/guest`);
};

const refreshToken = (data: any) => {
  return axios.post(`${AUTH_DOMAIN}/auth/guest/refresh-token`, { ...data });
};

const authServices = {
  getTokens,
  refreshToken,
};

export default authServices;
